module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/shape/shapesprite-59e12d.svg";